import { Flex, FlexProps } from 'theme-ui';

export interface CardRowProps extends FlexProps {
  withBottomBorder?: boolean;
}

const CardRow: React.FC<CardRowProps> = ({ withBottomBorder, sx, ...props }) => (
  <Flex
    sx={{
      justifyContent: 'space-between',
      alignItems: 'center',
      py: 's',
      borderBottom: 'solid',
      borderBottomWidth: withBottomBorder ? 'regular' : 'borderless',
      borderBottomColor: 'veloGrey3',
      ...sx
    }}
    {...props}
  />
);

export default CardRow;
